import { useSelector } from 'react-redux';

// Currency is hardcoded to EUR. It is never read from or written to
// localStorage, and cannot be changed at runtime.
const CURRENCY = "EUR";
const noop = () => {};

function usePrice() {
    const currencies = useSelector((state) => state.currency);
    const {list} = currencies;
    const currency = CURRENCY;
    const fallbackCurrency = CURRENCY;
    const setCurrency = noop;
    const setFallbackCurrency = noop;

    const convert = price => {

        return (
            getConvertedPrice(currency, price) ??
            getCurrencySymbol(currency) + " " + price.toFixed(2)
        )
    }

    const getCurrencySymbol = (currency) => {
        switch (currency) {
            case "EUR":
                return "€";
            default:
                return currency;
        }
    }

    const getConvertedPrice = (currency, price) => {
        let currencyData = list?.filter((curr) => curr.name?.toLowerCase() === currency.toLowerCase())[0];

        if(currencyData) {
            const newPrice = currencyData.converted_value * price;

            return getCurrencySymbol(currency) + " " + newPrice.toFixed(2);
        }
    }

    return {
        currency,
        setCurrency,
        fallbackCurrency,
        setFallbackCurrency,
        c: convert,
    }
}

export default usePrice;